import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src431700410/src/src/templates/markdown-page.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Metadata = makeShortcode("Metadata");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>
  Terms and Conditions applicable to .Asia Auction Participants and Registrants
    </h1>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>
    <p>
  <strong>1. Additional Definitions</strong>
    </p>
    <blockquote>
	<p>1.1 Applicant means a natural or moral person seeking to use the services of the Registrar and/or Pool to become a Registrant of a .ASIA domain name, and the Applicant Party to this Agreement;</p>
	<p>1.2 DotAsia means DotAsia Organisation Limited; </p>
	<p>1.3 Participant means a natural or moral person whose name appears on the Registry qualified Auction list, and being the Applicant, or the Applicant's agent (e.g. the OPN Contact as defined by the Registry and/or the Registrar acting as agent for the Applicant), and who actively participates in the Auction;</p>
	<p>1.4 Parties means the Registrar and the Applicant;</p>
	<p>1.5 Party means either the Registrar or the Participant as the context requires;</p>
	<p>1.6 Pool means Pool.com Inc., a Canadian corporation with offices at 300-12 York St. Ottawa, ON, Canada, K1N 5S6 and the sole and exclusive party named by DotAsia to run .ASIA auctions;</p>
	<p>1.7 Registrar means the Registrar party to this Agreement;</p>
	<p>1.8 Registrar/Applicant Agreement means this Agreement entered into between the Registrar and the Applicant;</p>
	<p>1.9 Registry means DOTASIA organization;</p>
	<p>1.10 Registry Services Provider means Afilias Limited, a company incorporated under the laws of Ireland and having its principle offices at Office 110, 52 Broomhill Road, Tallaght, Dublin 24, its successors and assigns as designated by DotAsia.</p>
    </blockquote>
    <p>
  <strong>2. Fees</strong>
    </p>
    <p>
  On the application for registration of a domain name, we will charge you the
  Application Verification Fee as required by the Registry (applicable in
  Sunrise applications only), and a Processing Fee.
    </p>
    <p>
  On the registration of a domain name, we will charge you a Registration Fee,
  an ICANN Fee and a Processing Fee.
    </p>
    <p>
  In the event the domain name goes to an auction, we will charge you any and
  all auction fees related to the domain name you win, as such fees are charged
  to us by Pool.
    </p>
    <p>
  <strong>3. Agency</strong>
    </p>
    <p>
  Applicant agrees that any and all actions taken by the Participant are actions
  taken on the Applicant's behalf, and with its full authority, and it ratifies
  any and all such actions.
    </p>
    <p>
  <strong>4. Contract for the Benefit of Third Parties</strong>
    </p>
    <p>
  Applicant and Registrar acknowledge and agree that this Agreement is intended
  to be for the benefit of Pool and the Registry. For the avoidance of doubt,
  Applicant and Registrar acknowledge and agree that this agreement in no
  fashion binds or obligates Pool or the Registry.
    </p>
    <p>
  <strong>5. Disclaimer of Warranty</strong>
    </p>
    <p>
  APPLICANT ACKNOWLEDGES AND AGREES THAT THE POOL SERVICES ARE PROVIDED "AS IS,"
  AND THAT POOL MAKES NO REPRESENTATIONS OR WARRANTIES, EXPRESS OR IMPLIED,
  STATUTORY OR OTHERWISE, AND SPECIFICALLY DISCLAIMS, ON ITS OWN BEHALF ON AND
  BEHALF OF ITS SUPPLIERS AND LICENSORS, ANY WARRANTIES AS TO THE USEFULNESS,
  ACCURACY, RELIABILITY, NON-INFRINGEMENT OR EFFECTIVENESS OF SUCH POOL SERVICES
  OR THAT ANY OF SUCH POOL SERVICES WILL BE UNINTERRUPTED, ERROR FREE, OR THAT
  DEFECTS HAVE OR WILL BE CORRECTED, OR THAT SUCH POOL SERVICES WILL MEET THE
  NEEDS OF ANY PARTY. WITHOUT LIMITING THE FOREGOING, POOL DISCLAIMS ALL
  WARRANTIES OF REASONABLE SKILL OR CARE. IN NO EVENT WILL POOL BE LIABLE TO
  REGISTRAR OR PARTICPANT FOR ANY FAILURE, DISRUPTION, DOWNTIME, INCORRECT
  LINKAGE OR OTHER NON-PERFORMANCE OF THE POOL SERVICES. POOL'S SOLE LIABILITY,
  AND REGISTRAR'S SOLE REMEDY, WITH RESPECT TO SUCH WARRANTY WILL BE POOL'S
  OBLIGATION TO CORRECT ERRORS WITH A LEVEL OF EFFORT COMMENSURATE WITH THE
  SEVERITY OF THE ERROR.
    </p>
    <p>
  <strong>6. Limitation of Liability</strong>
    </p>
    <p>
  IN NO EVENT WILL POOL'S LIABILITY ARISING OUT OF OR RELATED TO THIS AGREEMENT
  FROM ANY CAUSE EXCEED $ 100.00.
    </p>
    <p>
  IN ADDITION, IN NO EVENT WILL POOL, ITS AFFILIATES, OR EACH OF THEIR
  RESPECTIVE DIRECTORS, OFFICERS, SHAREHOLDERS, EMPLOYEES, CONTRACTORS OR AGENTS
  BE RESPONSIBLE OR LIABLE FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL,
  EXEMPLARY, PUNITIVE OR OTHER DAMAGES (INCLUDING BUT NOT LIMITED TO LOSS OF
  REVENUES OR LOSS OF PROF¬ITS), EVEN IF POOL, ITS AFFILIATES, OR ANY OF THEIR
  RESPCETIVE DIRECTORS, OFFICERS, SHAREHOLDERS, EMPLOYEES, CONTRACTORS OR AGENTS
  HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, UNDER ANY CONTRACT,
  NEGLIGENCE, STRICT LIABILITY OR OTHER THEORY ARISING OUT OF OR RELATING IN ANY
  WAY TO POOL SERVICES, OR ANY OTHER SUBJECT MATTER OF THIS AGREEMENT.
    </p>
    <p>
  POOL WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY DELAY IN FURNISHING
  POOL SERVICES TO THE REGISTRAR OR ANY OTHER PERFORMANCE UNDER THIS AGREEMENT,
  INCLUDING DELAYS IN TRANSMISSION OF DATA.
    </p>
    <p>
  <strong>7. Indemnity</strong>
    </p>
    <p>
  Applicant will defend, indemnify and hold Pool, its officers, directors,
  shareholders, employees, contractors, agents, successors and assigns harmless
  against any liability, or any litigation cost or expense (including attorneys'
  fees), arising out of acts or omissions of the Applicant's and/or the
  Registrar's agents or employees, breach of any provisions of this agreement,
  or operation of the Applicant's and/or Registrar's business. Pool will provide
  the Applicant and Registrar with written notice of such claim. Applicant will
  not enter into any settlement or compromise of any claim subject to
  indemnification under this clause, without Pool's prior written permission,
  which permission shall not be unreasonably withheld or delayed.
    </p>
    <p>
  You will indemnify, to the maximum extent permitted by law, defend and hold
  harmless the Registry, the Registry Service Provider, the Registrar and Pool,
  and their directors, officers, employees and agents from and against any and
  all claims, damages, liabilities, costs and expenses, including reasonable
  legal fees and expenses, arising out of or relating to the your domain name
  registration and or use. This indemnification obligation shall survive the
  termination or expiration of the registration agreement.
    </p>
    <p>
  <strong>8. Additional Registry imposed obligations</strong>
    </p>
    <p>
  To the extent Registry Policies are applicable to or contemplate compliance by
  you, you are obligated in the manner set forth by the DotAsia Registry from
  time to time in the Registry Policies, to adhere to Registry Policies.
    </p>
    <p>
  Furthermore, and in addition to the foregoing, you shall comply with / adhere
  to (as appropriate):
    </p>
    <blockquote>
  <p>
    ICANN requirements, standards, policies, procedures, and practices for which
    DotAsia has monitoring responsibility in accordance with the Registry
    Agreement or other arrangement with ICANN;
  </p>
  <p>
    Operational standards, policies, procedures, and practices for the .ASIA
    Registry established from time to time by DotAsia in a non-arbitrary manner
    as Registry Policies, applicable to all registrars and/or Registered Name
    Holders, and consistent with the Registry Agreement shall be effective upon
    thirty (30) days' notice by DotAsia to Registrar
  </p>
  <p>
    The following provision: "Notwithstanding anything in this Agreement to the
    contrary, DotAsia Organisation Limited ("DotAsia"), the Registry Operator of
    the .ASIA TLD, is and shall be an intended third party beneficiary of this
    Agreement. As such, the parties to this Agreement acknowledge and agree that
    the third party beneficiary rights of DotAsia have vested and that DotAsia
    has relied on its third party beneficiary rights under this Agreement in
    agreeing to <Metadata name="title" mdxType="Metadata" /> being a registrar for the .ASIA TLD.
    Additionally, the third party beneficiary rights of DotAsia shall survive
    any termination or expiration of this Agreement."
  </p>
  <p>
    Consent to the use, copying, distribution, publication, modification and
    other processing of your Personal Data by DotAsia and its designees and
    agents in a manner consistent with the purposes specified pursuant to
    Subsection 2.6 and with relevant mandatory local data protection, laws and
    privacy;
  </p>
  <p>
    Submit to proceedings commenced under ICANN's Uniform Domain Name Dispute
    Resolution Policy ("UDRP");
  </p>
  <p>
    Submit to proceedings commenced under ICANN's Charter Eligibility Dispute
    Resolution Policy ("CEDRP");
  </p>
  <p>
    Immediately correct and update the registration information for the
    Registered Name during the registration term for the Registered Name;
  </p>
  <p>
    Acknowledge and agree to comply with the .ASIA Charter Eligibility
    Requirement, including the following provision: "The Registrant Contact
    represents and warrants that it has made known to the Charter Eligibility
    Declaration Contact (CED Contact), and the CED Contact has agreed, that the
    Registrant Contact and the CED Contact will CED Contact will jointly be
    defined as the Registered Name Holder, and that it shall be jointly
    responsible for the Registered Name in the event of a dispute or a challenge
    over the Registered Name Holder's legal entitlement to or the ownership of
    the Registered Name. The CED Contact shall be bound by the provisions in the
    DotAsia Organisation Limited's .ASIA Charter Eligibility Requirement Policy
    published from time to time.
  </p>
  <p>
    Registered Name Holder acting as Registrant Contact agrees that it has
    obtained an agreement from the CED Contact that the Registrant Contact shall
    remain the Operating Contact for all operations of the domain, including but
    not limited to domain transfer and updates.
  </p>
  <p>
    Agree to be bound by the terms and conditions in the initial launch and
    general operations of the Registry TLD, including without limitation the
    Start-Up Policies. Where such terms and conditions include the submission to
    a binding arbitration for disputes arising from the Start-Up process or any
    allocation of domain names.
  </p>
  <p>
    Acknowledge and agree that DotAsia and Registry Services Provider, acting in
    consent with DotAsia, reserves the right to deny, cancel or transfer any
    registration that it deems necessary, in its sole discretion (i) to protect
    the integrity security, and stability of the registry; (ii) to comply with
    all appropriate laws, government rules or requirements, requests of law
    enforcement, in compliance with any dispute resolution process; (iii) to
    avoid any liability, civil or criminal, on the part of DotAsia as well as
    its affiliates, subsidiaries, officers, directors, representatives,
    employees, and stockholders; (iv) for violations of the terms and conditions
    herein: or (v) to correct mistakes made by DotAsia, the Registry Services
    Provider or any registrar in connection with a domain name registration.
    DotAsia also reserves the right to freeze a Registered Name such as placing
    a domain name on hold, lock, or other status during the resolution of a
    dispute.
  </p>
  <p>
    Submit to proceedings commenced under other dispute policies as set forth by
    DotAsia from time to time in the Registry Policies, including but not
    limited to expedited processes for suspension of a domain name by claims
    sought by intellectual property right holders, Internet engineering and
    security experts or other competent claimants in the purpose of upholding
    the stability, security and integrity of the .ASIA Registry.
  </p>
    </blockquote>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      